"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionRow = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const components_2 = require("../../../../../components");
const getArrowDirection_1 = require("../../../../../helpers/utils/getArrowDirection");
const components_3 = require("../../../../../components/DashboardWidgets/components");
require("./types");
exports.SessionRow = react_1.default.memo(({ icon, text, description, value, countDifference }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_3.IconWithTextCell, { icon: icon, text: text, description: description, width: "80%" }),
        react_1.default.createElement("td", { align: "right" },
            react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, align: components_1.STACK_ALIGN.end },
                react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.center, gap: components_1.STACK_GAP.xs, style: !countDifference ? { marginRight: 20 } : undefined },
                    react_1.default.createElement(components_1.Text, { size: components_1.TEXT_SIZE.xl, align: components_1.TEXT_ALIGN.right }, value),
                    countDifference && react_1.default.createElement(components_2.ArrowIcon, { direction: getArrowDirection_1.getArrowDirection(countDifference) }))))));
});
//# sourceMappingURL=SessionRow.js.map